import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  FormGroup,
  Input,
  Table,
  Row,
  Col,
  Tooltip,
} from "reactstrap";
import useToken from "../../helpers/useToken";
import useTimeZone from "../../helpers/useTimeZone";
import PaginationCustom from "../PaginationCustom/PaginationCustom";
import TMHLoader from "../TMHLoader/TMHLoader";
import { Link } from "react-router-dom";
import {
  parseCustomTime,
  utils_StringIsNullOrEmpty,
} from "../../helpers/utils";

export default function UserTable({ notify }) {
  const [users, setUsers] = useState();
  const { token } = useToken();
  const { timeZone } = useTimeZone();
  const [isLoading, setIsLoading] = useState(false);
  const [pager, setPager] = useState({
    size: 10,
    offset: 0,
    text: "",
    method1: "All",
    method2: "All",
    method3: "All",
  });

  const [tooltip2, setTooltip2] = useState(false);
  const [totalUser, setTotalUser] = React.useState(5000);

  const deleteUser = (userId, pin) => {
    if (window.confirm(`Do you want delete user pin: ${pin}?`)) {
      setIsLoading(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Cache-Control", "no-cache");
      myHeaders.append("Access-Token", token);

      var requestOptions = {
        method: "DELETE",
        headers: myHeaders,
      };

      fetch(
        process.env.REACT_APP_BASE_URL + "users/" + String(userId),
        requestOptions
      )
        .then((response) => {
          return new Promise((resolve) =>
            response.json().then((json) =>
              resolve({
                status: response.status,
                ok: response.ok,
                json,
              })
            )
          );
        })
        .then(
          async (result) => {
            if (result.ok) {
              notify("tl", `Delete user ${pin} success!`, "success");
              setPager({ ...pager });
            } else {
              notify("tl", `Delete user ${pin} failed!`, "danger");
              console.error(result);
              setIsLoading(false);
            }
          },
          (error) => {
            notify("tl", `Delete user ${pin} failed!`, "danger");
            console.error(error);
          }
        );
    }
  };

  useEffect(() => {
    const initData = async () => {
      console.log("UserTable: update data");
      setIsLoading(true);
      var myHeaders = new Headers();
      myHeaders.append("Cache-Control", "no-cache");
      myHeaders.append("Access-Token", token);

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
      };

      var params = new URLSearchParams({
        page_size: pager.size,
        offset: pager.offset,
        search_text: pager.text,
        method1: pager.method1,
        method2: pager.method2,
        method3: pager.method3,
      });

      fetch(process.env.REACT_APP_BASE_URL + "users?" + params, requestOptions)
        .then((response) => {
          return new Promise((resolve) =>
            response.json().then((json) =>
              resolve({
                status: response.status,
                ok: response.ok,
                json,
              })
            )
          );
        })
        .then(async (result) => {
          var json = result.json;
          if (result.ok) {
            setUsers(json.data);
            setTotalUser(json.page_dto.total);
            setIsLoading(false);
          } else {
            console.log(result.json.message);
            setIsLoading(false);
          }
        });
    };

    initData();
  }, [pager, setIsLoading, token]);

  const exportUserCsv = () => {
    console.log("exportUserCsv");
    setIsLoading(true);
    var myHeaders = new Headers();
    myHeaders.append("Cache-Control", "no-cache");
    myHeaders.append("Access-Token", token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
    };

    var params = new URLSearchParams({
      timezone: timeZone,
    });

    fetch(
      process.env.REACT_APP_BASE_URL + "users/export_user_csv?" + params,
      requestOptions
    )
      .then((response) => {
        return new Promise((resolve) =>
          response.blob().then((blob) =>
            resolve({
              status: response.status,
              ok: response.ok,
              blob,
            })
          )
        );
      })
      .then(async (result) => {
        var blob = result.blob;
        if (result.ok) {
          setIsLoading(false);
          var file = window.URL.createObjectURL(blob, "csv");
          // window.location.assign(file);
          var anchor = document.createElement("a");
          anchor.download = "users.csv";
          anchor.href = file;
          anchor.click();
        } else {
          console.log(result.json.message);
          setIsLoading(false);
        }
      });
  };

  return (
    <TMHLoader active={isLoading}>
      <Row>
        <Col>
          <Card>
            <CardHeader>
              <Row>
                <Col md="2">
                  <CardTitle tag="h3">Users ({totalUser})</CardTitle>
                </Col>
                <Col md="3">
                  <CardTitle tag="h3">
                    {" "}
                    <div>Primary Method</div>
                    <select
                      style={{ fontSize: 16 }}
                      value={pager?.method1}
                      onChange={(e) =>
                        setPager({
                          ...pager,
                          offset: 0,
                          method1: e.target.value,
                          method2: "All",
                          method3: "All",
                        })
                      }
                    >
                      <option>All</option>
                      <option>FreeMovieHouse</option>
                      <option>FreeMovieSpin</option>
                      <option>PPC/Mobile</option>
                      <option>Extension</option>
                      <option>Display</option>
                    </select>
                  </CardTitle>
                </Col>
                <Col md="2">
                  <CardTitle tag="h4">
                    {" "}
                    <div>Platform</div>
                    <select
                      style={{ fontSize: 14 }}
                      value={pager?.method2}
                      onChange={(e) =>
                        setPager({
                          ...pager,
                          offset: 0,
                          method2: e.target.value,
                          method3: "All",
                        })
                      }
                    >
                      <option>All</option>
                      <option>Mobile</option>
                      <option>Desktop</option>
                    </select>
                  </CardTitle>
                </Col>
                <Col md="2">
                  <CardTitle tag="h4">
                    {" "}
                    <div>OS</div>
                    <select
                      style={{ fontSize: 14 }}
                      value={pager?.method3}
                      onChange={(e) =>
                        setPager({
                          ...pager,
                          offset: 0,
                          method3: e.target.value,
                        })
                      }
                    >
                      <option>All</option>
                      <option>iOS</option>
                      <option>Android</option>
                    </select>
                  </CardTitle>
                </Col>
                <Col md="2">
                  Export Users{" "}
                  <Button
                    onClick={() => exportUserCsv()}
                    className="btn-icon btn-simple"
                    color="success"
                    size="sm"
                  >
                    <i className="fa-solid fa-file-export" />
                  </Button>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Row>
                <Col md="4" className="pt-2">
                  <CardTitle tag="h5">
                    Shows{" "}
                    <select
                      value={pager?.size}
                      onChange={(e) =>
                        setPager({
                          ...pager,
                          size: e.target.value,
                          text: pager.text,
                          offset: 0,
                        })
                      }
                    >
                      <option>10</option>
                      <option>25</option>
                      <option>50</option>
                      <option>100</option>
                    </select>{" "}
                    entries
                  </CardTitle>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <label>Search</label>
                    <Input
                      placeholder="Search User Name, User ID, PIN, Device ID, Mobile Id"
                      type="text"
                      onChange={(e) => {
                        let text = e.target.value.replace(/\s/g, "");
                        if (text.length > 3 || text.length === 0) {
                          setPager({
                            ...pager,
                            size: pager.size,
                            offset: 0,
                            text: text,
                          });
                        }
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Table striped className="tablesorter">
                <Tooltip
                  isOpen={tooltip2}
                  delay={{ show: 0, hide: 0 }}
                  target="channelId"
                  placement="bottom"
                  toggle={() => setTooltip2(!tooltip2)}
                >
                  Unique id given to the device after install of TMH Roku App
                </Tooltip>
                <thead className="text-primary">
                  <tr>
                    <th>Name</th>
                    <th>Sign up</th>
                    <th>Method</th>
                    <th>Email</th>
                    <th className="text-center">Email IP</th>
                    <th>Email Verified</th>
                    <th>Pin</th>
                    <th>PIN Verified</th>
                    <th>Mobile ID</th>
                    <th className="text-center">Mobile IP</th>
                    <th>Notification</th>
                    <th
                      className="text-center"
                      style={{
                        cursor: "pointer",
                      }}
                      id="channelId"
                    >
                      Roku Device IFA
                    </th>
                    <th className="text-center">Roku IFA IP</th>
                    <th className="text-center">TMH install date</th>
                    <th className="text-center">RMR install date</th>
                    <th className="text-center">EXT install date</th>
                    <th className="text-center">ACTIONS</th>
                  </tr>
                </thead>
                <tbody>
                  {users?.map((userData) => {
                    return (
                      <tr key={userData.user_id}>
                        <td>
                          {userData.first_name} {userData.last_name}
                        </td>
                        <td>
                          {parseCustomTime(userData.signup_date, timeZone)}
                        </td>
                        <td>
                          {userData.SRM_install_date != null ? "SRM - " : ""}
                          {utils_StringIsNullOrEmpty(userData.method) &&
                          !utils_StringIsNullOrEmpty(userData.advertising_id)
                            ? "FreeMovieSpin"
                            : userData.method === "FreeMovieSpin"
                            ? userData.mobile_id
                              ? "Mobile/FreeMovieSpin"
                              : "FreeMovieSpin"
                            : userData.method}
                        </td>
                        <td>{userData.email}</td>
                        <td>{userData.email_ip}</td>
                        <td>{userData.email_verified ? "YES" : "NO"}</td>
                        <td>{userData.pin}</td>
                        <td>{userData.device_id ? "YES" : "NO"}</td>
                        <td>{userData.mobile_id}</td>
                        <td>{userData.mobile_ip}</td>
                        <td>{userData.notification ? "YES" : "NO"}</td>
                        <td>{userData.advertising_id}</td>
                        <td>{userData.roku_ip}</td>
                        <td className="text-center">
                          {parseCustomTime(userData.TMH_install_date, timeZone)}
                        </td>
                        <td className="text-center">
                          {parseCustomTime(userData.RMR_install_date, timeZone)}
                        </td>
                        <td className="text-center">
                          {parseCustomTime(userData.EXT_install_date, timeZone)}
                        </td>
                        <td className="text-center">
                          <Link
                            to={"/edit-user/" + userData.user_id}
                            target="_blank"
                          >
                            <Button
                              className="btn-icon btn-simple"
                              color="warning"
                              size="sm"
                            >
                              <i className="fa fa-edit"></i>
                            </Button>
                          </Link>
                          {` `}
                          <Button
                            onClick={() =>
                              deleteUser(userData.user_id, userData.pin)
                            }
                            className="btn-icon btn-simple"
                            color="danger"
                            size="sm"
                          >
                            <i className="fa fa-times" />
                          </Button>
                          {` `}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationCustom
                pager={pager}
                total={totalUser}
                setPager={setPager}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </TMHLoader>
  );
}
